import MarkdownIt from 'markdown-it';
import { useMemo } from 'react';

export const useMarkdown = () => {
  return useMemo(() => {
    const md = new MarkdownIt({
      html: true,
      linkify: true,
      typographer: true,
    });

    const defaultRender =
      md.renderer.rules.link_open ??
      ((tokens, idx, options, env, self) =>
        self.renderToken(tokens, idx, options));

    md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
      tokens[idx].attrSet('target', '_blank');
      tokens[idx].attrSet('rel', 'noopener noreferrer');
      return defaultRender(tokens, idx, options, env, self);
    };

    return md;
  }, []);
};

export default useMarkdown;
